module.exports = __webpack_public_path__ + "static/media/CalendarBlank.8dcbe11f.svg";